import angular from "angular";
import usersControl from "./users-control.component";
import userRoles from "./user-roles/user-roles";
import userPermissions from "./user-permissions/user-permissions";

angular.module('usersControl', [usersControl, userRoles, userPermissions]);

export default 'usersControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/users-control.module.js